import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { ModifyDepartmentComponent } from './modify-department.component';

@NgModule({
   declarations: [ModifyDepartmentComponent],
   imports: [
      CommonModule,
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatInputModule,
      ReactiveFormsModule,
      EntitySelectModule,
   ],
})
export class ModifyDepartmentModule {}
